import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/Signup'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/profile/authentication/overview/ResetPassForm'));

const NotFound = () => {
  return <Redirect to="/" />;
};

const FrontendRoutes = () => {
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        

        <Route path="/forgotPassword" component={ForgotPass} />
        <Route path="/register" component={SignUp} />
        {/* <Route path="/resetpassword/:id" component={ResetPassword} /> */}
        <Route path="/resetpassword/:id" component={ResetPassword} />
        {/* <Route path="/resetpassword" component={ResetPassword} /> */}
        <Route exact path="/" component={Login} />
      </Suspense>
    </Switch>
  );
};

export default AuthLayout(FrontendRoutes);
